import axios from 'axios';
// import {
//     Toast
// } from 'mint-ui';
let http = axios.create({
    // baseURL: 'http://192.168.0.101/api/',
    baseURL:'http://123.157.155.34:8092/api/',
    transformRequest: [function (data) {
        let newData = '';
        for (let k in data) {
            if (data.hasOwnProperty(k) === true) {
                newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
            }
        }
        return newData;
    }]
});

function apiAxios(method, url, params, response) {
    http({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
    }).then((res) => {
        // 对响应数据做点什么
        if (res.status === 200) { // 当status=0时，说明当前接口报错
            let data = res.data
            response(data)
            // if (data.code === 1) {
            //     response(data.data)
            // } else {
            //     if (data.msg) {
            //         Toast({
            //             message: data.msg,
            //             iconClass: 'icon icon-error'
            //         });
            //     }
            // }
        }
    }).catch(function (err) {
        return Promise.reject(err);
    })
}

export default {
    get: function (url, params, response) {
        return apiAxios('GET', url, params, response)
    },
    post: function (url, params, response) {
        return apiAxios('POST', url, params, response)
    },
    put: function (url, params, response) {
        return apiAxios('PUT', url, params, response)
    },
    delete: function (url, params, response) {
        return apiAxios('DELETE', url, params, response)
    }
}